import React, { useEffect, useState } from 'react';
import { Select, DatePicker, Space } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const currentYear = dayjs().year();
const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
const months = [
  { label: 'Custom', value: 'custom' },
  { label: 'January', value: 0 },
  { label: 'February', value: 1 },
  { label: 'March', value: 2 },
  { label: 'April', value: 3 },
  { label: 'May', value: 4 },
  { label: 'June', value: 5 },
  { label: 'July', value: 6 },
  { label: 'August', value: 7 },
  { label: 'September', value: 8 },
  { label: 'October', value: 9 },
  { label: 'November', value: 10 },
  { label: 'December', value: 11 },
];

const DateRangeFilter = ({
  value,
  onChange,
  placeholder = 'Date Range',
  defaultYear = currentYear,
  defaultMonth,
}) => {
  const [year, setYear] = useState(value?.year ?? defaultYear);
  const [month, setMonth] = useState(value?.month ?? defaultMonth);
  const [dateRange, setDateRange] = useState(
    value?.dateRange ?? undefined
  );

  // Sync with parent
  useEffect(() => {
    if (month !== undefined && month !== 'custom') {
      // When a specific month is selected, only pass the year and month
      onChange && onChange({ year, month });
    } else if (month === undefined) {
      onChange && onChange({ year });
    }
    // eslint-disable-next-line
  }, [year, month]);

  // Update dateRange when year or month changes (unless custom)
  useEffect(() => {
    if (month !== undefined && month !== 'custom') {
      const start = dayjs().year(year).month(month).startOf('month');
      const end = dayjs().year(year).month(month).endOf('month');
      setDateRange([start, end]);
    } else if (month === undefined) {
      setDateRange(undefined);
    }
  }, [year, month]);

  const handleYearChange = (value) => setYear(value);
  const handleMonthChange = (value) => setMonth(value);
  const handleRangeChange = (range) => {
    setDateRange(range);
    // When custom range is selected, ensure we pass the full date range
    onChange && onChange({ year, month: 'custom', dateRange: range });
  };

  return (
    <Space>
      <Select value={year} onChange={handleYearChange} style={{ width: 100 }} placeholder="Year">
        {years.map(y => (
          <Select.Option key={y} value={y}>{y}</Select.Option>
        ))}
      </Select>
      <Select value={month} onChange={handleMonthChange} style={{ width: 120 }} placeholder="Month" allowClear>
        {months.map(opt => (
          <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
        ))}
      </Select>
      {month === 'custom' && (
        <RangePicker
          value={dateRange}
          onChange={handleRangeChange}
          allowClear={false}
          style={{ width: 240 }}
          placeholder={['Start Date', 'End Date']}
        />
      )}
    </Space>
  );
};

export default DateRangeFilter; 